import { useAuthContext } from '@/context/AuthContext';
import { useParams } from "react-router-dom";

import {gql} from '@apollo/client';
import {useMutation} from '@apollo/client/react';

const DELETE_INVOICE = gql`
  mutation DeleteConsultantInvoice($uuid: ID!) {
    deleteConsultantInvoice(uuid: $uuid)
  }
`;
export const useDeleteConsultantInvoice = () => {
  const [deleteInvoiceMutation, { loading, error, data }] = useMutation(DELETE_INVOICE);

  const deleteConsultantInvoice = async (uuid) => {
    const response = await deleteInvoiceMutation({
      variables: { uuid },
    });
    return response.data.deleteConsultantInvoice;
  };

  return { deleteConsultantInvoice, loading, error, data };
};
